import Header from './Header';
import background from './img/softwarePartners.webp';
import screenshotWordpressUpload from './img/screenshot-wp-uploadpng.png';
import screenshotWpAdd from './img/screenshot-wp-add.png';
import screenshotWpUploadPlugin from './img/screenshot-wp-uploadplugin.png';
import screenshotWpPluginPage from './img/screenshot-wp-plugin-page.png';
import screenshotWooCommerceSettings from './img/screenshot-woo-commerce-settings.png';
import screenshotWooCommercePaymentGateway from './img/screenshot-woo-commerce-payement-gateway.png';
import screenshotDeveloperHub from './img/screenshot-developer-hub.webp';
import screenshotCreateNewApp from './img/screenshot-create-new-application.webp';
import screenshotSecrets from './img/screenshot-secrets.webp';
import screenshotWooCommerceGatewaySettings from './img/screenshot-woo-commerce-gateway-settings.webp';
import screenshotWebhooks from './img/screenshot-webhooks.webp';
import screenshotAcceptableMethods from './img/screenshot-accepted-methods.webp';
import screenshotLogging from './img/screenshot-logging.webp';
import MobileNavigation from './MobileNavigation';
import { CopyBlock, dracula } from 'react-code-blocks';
import Footer from './Footer';
import { Link } from 'react-router-dom';

const DeveloperWooCommerce = () => {
  return (
    <>
      <MobileNavigation />
      <section className="bg-[#212121] woo-commerce">
        <div
          className="w-full pb-28"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: '200% 200%',
            backgroundPosition: 'bottom center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Header />
          <div className="p-4 row md:p-8 how">
            <h3 className="text-white large">iQ Pro+ WooCommerce Plugin</h3>
          </div>
          <div className="flex p-16 row flex-col justify-center flex-start gap-6 self-stretch rounded-[28px] bg-white !mb-10">
            <h2 className="text-black large">Overview</h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The{' '}
              <Link
                to="/integrations-woo-commerce-downloads"
                style={{ color: '#007bff', textDecoration: 'underline' }}
              >
                iQ Pro+ payment gateway plugin
              </Link>{' '}
              provides seamless integration between WooCommerce and your iQ Pro+ Gateway, enabling
              merchants to accept credit card and ACH payments with secure, PCI-compliant
              tokenization. The plugin features customer payment method vaulting, allowing logged-in
              users to save and manage payment methods for faster checkouts. This guide walks you
              through configuring and using the plugin, including setup, payment processing,
              customer vaulting, and managing transactions through the WooCommerce admin interface.
            </p>
            <h2 className="font-normal text-black">On this page</h2>
            <ol className="ml-5 list-decimal gap-x-12 marker:text-gray-500 md:columns-2 [&>li]:break-inside-avoid [&>li]:py-1">
              <li className="text-black light">
                <a
                  href="#installation-and-setup"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Installation &amp; Setup
                </a>
              </li>
              <li className="text-black light">
                <a
                  href="#app-registration-setup"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  App Registration Setup
                </a>
              </li>
              <li className="text-black light">
                <a href="#settings-page" style={{ color: '#007bff', textDecoration: 'underline' }}>
                  Settings Page
                </a>
              </li>
              <li className="text-black light">
                <a
                  href="#credentials-and-environment"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Credentials and Environment
                </a>
              </li>
              <li className="text-black light">
                <a href="#webhook-setup" style={{ color: '#007bff', textDecoration: 'underline' }}>
                  Webhook Setup
                </a>
              </li>
              <li className="text-black light">
                <a
                  href="#webhook-creation"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Webhook Creation
                </a>
              </li>
              <li className="text-black light">
                <a
                  href="#accepted-methods"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Accepted Methods
                </a>
              </li>
              <li className="text-black light">
                <a href="#logging" style={{ color: '#007bff', textDecoration: 'underline' }}>
                  Logging
                </a>
              </li>
              <li className="text-black light">
                <a href="#styling" style={{ color: '#007bff', textDecoration: 'underline' }}>
                  Styling
                </a>
              </li>
            </ol>
            <h2 className="font-normal text-black">Prerequisites</h2>
            <p className="text-black light">
              This plugin currently is compatible with the following versions of WordPress
            </p>
            <table className="tg" style={{ undefined, tableLayout: 'fixed', width: '100%' }}>
              <colgroup>
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
                <col style={{ width: '25%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th className="font-bold text-center text-black">Component</th>
                  <th className="font-bold text-center text-black">Compatible Versions</th>
                  <th className="font-bold text-center text-black">
                    Recommended / Supported Versions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>PHP</b>
                  </td>
                  <td>8.0.x, 8.1.x, 8.2.x, 8.3.x</td>
                  <td>
                    <b>8.2.x – 8.3.x</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>WordPress</b>
                  </td>
                  <td>6.8.x, 6.9.x</td>
                  <td>
                    <b>6.9.x</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>WooCommerce</b>
                  </td>
                  <td>10.4.x</td>
                  <td>
                    <b>10.4.3</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <h2 id="installation-and-setup" className="scroll-mt-8 text-black large">
              Installation & Setup
            </h2>
            <p className="text-black light">
              This section covers the installation and setup process for the{' '}
              <Link
                to="/integrations-woo-commerce-downloads"
                style={{ color: '#007bff', textDecoration: 'underline' }}
              >
                iQ Pro+ WooCommerce Plugin
              </Link>
              .
            </p>
            <div className="my-4 callout">
              <p className="mb-0 text-black light">
                <strong>NOTE:</strong> Should you install a new version of the plugin, it is
                recommended you clear your cache to prevent potential errors in testing.
              </p>
            </div>
            <h2 className="font-normal text-black">Uploading the Plugin</h2>
            <ol className="ml-5 list-decimal">
              <li className="text-black light">
                In the <b>WordPress Admin Panel</b>, navigate to the <b>Plugins</b> section.
              </li>
              <li className="text-black light">
                Click either the <b>"Add Plugin"</b> option in the sidebar dropdown
                <img src={screenshotWordpressUpload} alt="Screenshot of WordPress Upload Plugin" />
                <br />
                or the <b>"Add New"</b> button on the Installed Plugins page.
                <img src={screenshotWpAdd} alt="Screenshot of WordPress Add" />
              </li>
              <li className="text-black light">
                At the top of the page, click the <b>"Upload Plugin"</b> button.
                <img
                  src={screenshotWpUploadPlugin}
                  alt="Screenshot of WordPress Upload Plugin page"
                />
              </li>
              <li className="text-black light">
                Upload the <code>.zip</code> file provided by Basys.
              </li>
              <li className="text-black light">
                Once the upload completes, click <b>“Install Now”</b> and then <b>“Activate”</b> to
                enable the plugin.
              </li>
              <li className="text-black light">
                Confirm that the plugin is active by returning to the <b>Plugins</b> tab and
                verifying its status.
                <img src={screenshotWpPluginPage} alt="Screenshot of WordPress Plugin page" />
              </li>
            </ol>
            <h2 className="font-normal text-black">Enabling the Payment Gateway</h2>
            <ol className="ml-5 list-decimal">
              <li className="text-black light">
                Navigate to the <b>WooCommerce</b> section in the WordPress Admin Panel and select{' '}
                <b>Settings</b>.
              </li>
              <li className="text-black light">
                Click the <b>Payments</b> tab.
                <img
                  src={screenshotWooCommerceSettings}
                  alt="Screenshot of WooCommerce Settings"
                  width="50%"
                />
              </li>
              <li className="text-black light">
                Scroll down to locate <b>Basys Processing iQPro+</b>.
              </li>
              <li className="text-black light">
                Toggle the switch to <b>Enable</b> the payment gateway.
                <img
                  src={screenshotWooCommercePaymentGateway}
                  alt="Screenshot of WordPress Plugin page"
                />
              </li>
            </ol>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              Once enabled, the <b>Basys iQPro+</b> gateway is officially registered as a
              WooCommerce payment processor and the secure iFrame will be available for use during
              checkout.
            </p>
            <h2 id="app-registration-setup" className="scroll-mt-8 text-black large">
              App Registration Setup
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              For this portion we will need to set up the app registration in your gateway to obtain
              your client ID and client secret. We will start in your gateway portal and navigate to{' '}
              <b>Developer Hub → Applications</b>
            </p>

            <img src={screenshotDeveloperHub} alt="Screenshot of Developer Hub" />
            <h2 className="font-normal text-black">Creating the Client Credentials</h2>
            <ol className="ml-5 list-decimal">
              <li className="text-black light">
                In the <b>Applications</b> page select <b>Create New +</b>
              </li>
              <li className="text-black light">
                Enter your <b>Application Name</b> and for role select Integrator Service Account
                and click Create
                <div className="my-4 callout">
                  <p className="mb-0 text-black light">
                    <strong>IMPORTANT:</strong> The role <span className="underline">MUST</span> be
                    Integrator Service Account or the plugin will not function.
                  </p>
                </div>
                <img src={screenshotCreateNewApp} alt="Screenshot of Create New Application" />
              </li>
              <li
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                Once created you will see <b>Client ID</b> listed below your applications name
                followed by a UUID. This is your <b>Client ID</b> that will be used in the{' '}
                <b>Config File Setup</b>
              </li>
              <li className="text-black light">
                Below <b>Details</b> you will see <b>Secrets</b>, select <b>+ Add New Secret</b> and
                enter your secrets name
                <img src={screenshotSecrets} alt="Screenshot of Secrets" />
                <div className="my-4 callout">
                  <p className="mb-0 text-black light">
                    <strong>NOTE:</strong> Once you create a new secret it will be display on the
                    page. This will be the only time to record this. Additionally you are allowed
                    only two secrets per application
                  </p>
                </div>
              </li>
              <li className="text-black light">
                You have now created your client ID and client secret. Save these credentials for
                the <b>Config File Setup</b> portion of the process
              </li>
            </ol>
            <h2 id="settings-page" className="scroll-mt-8 text-black large">
              Settings Page
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              Once the plugin has been successfully installed and activated, a new submenu item
              labeled <b>iQPro+ Gateway</b> will appear under the <b>WooCommerce</b> section in the
              WordPress Admin Panel.
            </p>
            <p className="text-black light">Navigate to:</p>
            <p className="font-semibold text-black">WooCommerce → iQPro+ Gateway</p>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              This settings page serves as the central configuration hub for the plugin and contains
              all options required to connect your WooCommerce store to the Basys iQPro+ gateway.
            </p>
            <p className="text-black light">From this page, you can:</p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                Configure <b>payment method availability</b>, such as Card-only or Card + ACH
                (depending on gateway setup).
              </li>
              <li className="text-black light">
                Receive your <b>Webhook URL</b> or edit your pre-generated <b>Webhook ID</b>
              </li>
              <li className="text-black light">
                Select which <b>environment</b> the plugin should operate in (Sandbox or
                Production).
              </li>
              <li className="text-black light">
                Enter your <b>Client ID</b> and <b>Client Secret</b> received from your gateway.
              </li>
              <li className="text-black light">
                Verify that the <b>credentials defined</b> are functioning correctly.
              </li>
              <li className="text-black light">
                View the <b>Logs</b> to assist in troubleshooting.
              </li>
            </ul>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              Any changes made on the Settings page take effect immediately after saving. It is
              recommended to complete all credential and webhook configuration steps prior to
              enabling the gateway on a live production site.
            </p>
            <h2 id="credentials-and-environment" className="scroll-mt-8 text-black large">
              Credentials and Environment
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The <b>Environment and API Credentials</b> section allows you to configure how the
              plugin connects to your iQPro+ gateway. From this screen, you will select the active
              environment and provide the corresponding authentication credentials.
            </p>
            <p className="text-black light">Navigate to:</p>
            <p className="font-semibold text-black">
              WooCommerce → iQPro+ Gateway → Environment and Credentials
            </p>
            <img
              src={screenshotWooCommerceGatewaySettings}
              alt="Screenshot of WooCommerce Gateway Settings"
            />
            <h2 className="font-normal text-black">Selecting an Environment</h2>
            <p className="text-black light">
              At the top of the page, choose which environment the plugin should operate in:
            </p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                <b>Sandbox</b> - Used for development and testing
              </li>
              <li className="text-black light">
                <b>Production</b> - Used for live transactions
              </li>
            </ul>
            <p className="text-black light">
              Only one environment can be active at a time. The selected environment determines
              which credentials are used when processing payments.
            </p>
            <h2 className="font-normal text-black">Entering API Credentials</h2>
            <p className="text-black light">
              For the selected environment, enter the following values provided by Basys:
            </p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                <code>Client ID</code>: The unique identifier for your registered application.
              </li>
              <li className="text-black light">
                <code>Client Secret</code>: A secure secret key used to authenticate API requests.
              </li>
              <li className="text-black light">
                <code>Gateway ID</code>: The identifier for the payment gateway assigned to your
                account.
                <div className="my-4 callout">
                  <p className="mb-0 text-black light">
                    <strong>IMPORTANT:</strong> Credentials must match the selected environment.
                    Sandbox credentials will not work in Production mode, and Production credentials
                    will not function in Sandbox mode.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-black light">
              After entering the required values, click <b>Save All Changes</b> to store your
              configuration.
            </p>
            <h2 className="font-normal text-black">Testing the API Connection</h2>
            <p className="text-black light">
              Once your credentials have been saved, you can validate them by clicking the{' '}
              <b>Test API Connection</b> button.
            </p>
            <p className="text-black light">This test confirms that:</p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">The Client ID and Client Secret are valid</li>
              <li className="text-black light">
                The Gateway ID is correctly associated with your account
              </li>
              <li className="text-black light">
                The plugin can successfully authenticate with the iQPro+ API
              </li>
            </ul>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              If the test fails, review the entered credentials and ensure the correct environment
              is selected. For additional guidance, refer to the <b>Troubleshooting</b> tab within
              the plugin settings.
            </p>
            <h2 id="webhook-setup" className="scroll-mt-8 text-black large">
              Webhook Setup
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The iQPro+ WooCommerce plugin uses webhooks to receive real-time transaction updates
              from the iQPro+ gateway. These updates allow the plugin to process transaction status
              changes dynamically and keep order data in sync with the gateway.
            </p>
            <img src={screenshotWebhooks} alt="Screenshot of Webhooks" />
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The plugin <b>automatically generates a Webhook URL and Webhook ID</b> during
              installation. These values are exposed within the plugin settings and are ready to be
              used when creating your webhook in the gateway portal.
            </p>
            <div className="my-4 callout">
              <p
                className="mb-0 text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <strong>IMPORTANT:</strong> Webhook IDs must be in UUID format in order to function
                correctly. While the plugin generates this value automatically, it can be manually
                edited from the Settings page if needed.
              </p>
            </div>
            <h2 id="webhook-creation" className="scroll-mt-8 text-black large">
              Webhook Creation
            </h2>
            <p className="text-black light">
              To register the webhook with your iQPro+ gateway, complete the following steps:
            </p>
            <ol className="ml-5 list-decimal">
              <li className="text-black light">
                Log in to your <b>iQPro+ Gateway Portal</b>.
              </li>
              <li className="text-black light">
                Navigate to: <b>Developer Hub → Webhooks</b>
              </li>
              <li className="text-black light">
                Click <b>Create New +</b>.
              </li>
            </ol>
            <h2 className="font-normal text-black">Webhook Configuration</h2>
            <p className="text-black light">
              When creating the webhook, configure the following fields:
            </p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                <b>Webhook Type</b>: Select <b>Transaction</b>
              </li>
              <li
                className="text-black light"
                style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
              >
                <b>Webhook URL</b>: Copy and paste the <b>Webhook URL provided by the plugin</b>.
                This URL is displayed in the plugin’s settings and is already formatted correctly
                for webhook delivery.
                <div className="my-4 callout">
                  <p
                    className="mb-0 text-black light"
                    style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
                  >
                    <strong>NOTE:</strong> Webhooks require a live, publicly accessible site with a
                    valid and trusted SSL certificate. Local development environments without HTTPS
                    will not receive webhook events.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-black light">
              Once all required fields are completed, click <b>Create</b> to save the webhook.
            </p>
            <h2 id="accepted-methods" className="scroll-mt-8 text-black large">
              Accepted Methods
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              On the <b>Settings</b> page, you can choose whether to accept <b>Card Only</b>{' '}
              payments or both <b>Card and ACH</b> payments. Your selection determines which payment
              options are displayed on your checkout page. Please note that card and ACH payments
              will only function if a <b>default processor</b> has been configured.
            </p>
            <img src={screenshotAcceptableMethods} alt="Screenshot of Accepted Methods" />
            <h2 id="logging" className="scroll-mt-8 text-black large">
              Logging
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              To help troubleshoot any errors that may occur this plugin comes with its own logging.
              You can find this under the <b>Troubleshooting</b> tab then selecting the{' '}
              <b>Open WooCommerce Logs</b> button or by going to <b>WooCommerce → Status → Logs</b>,
              should there be any they would be logged under the file names basys-payment-gateway
            </p>
            <img src={screenshotLogging} alt="Screenshot of Logging" />
            <h2 id="styling" className="scroll-mt-8 text-black large">
              Styling
            </h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              To ensure seamless integration with your site’s branding, the plugin applies only
              minimal default styling and relies primarily on your active theme and global site
              styles for overall appearance.
            </p>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              The included CSS establishes a clean, consistent baseline that works across a wide
              variety of WordPress themes while remaining flexible and easy to customize. No
              aggressive styling or layout overrides are applied by default.
            </p>
            <h2 className="font-normal text-black">Expected Styling Behavior</h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              Out of the box, the plugin is designed to exhibit the following behaviors:
            </p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                Automatically expand to <b>match the full width</b> of the container it is placed
                within.
              </li>
              <li className="text-black light">
                Display section titles and labels using <b>bold text and consistent spacing</b> for
                clarity.
              </li>
              <li className="text-black light">
                Structure Card and ACH entry forms using <b>flexible layouts</b> that adapt smoothly
                to both desktop and mobile viewports.
              </li>
              <li className="text-black light">
                Apply <b>uniform input styling</b> across all Card and ACH fields, including font
                size, padding, borders, and rounded corners.
              </li>
              <li className="text-black light">
                Maintain visual consistency between native WooCommerce elements and the embedded
                payment fields.
              </li>
              <li className="text-black light">
                Gracefully hide or reveal payment sections (Card, ACH, Vault options) based on
                configuration and user interaction.
              </li>
            </ul>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              This approach ensures the checkout experience feels native to your site while
              maintaining a consistent payment flow across implementations.
            </p>
            <h2 className="font-normal text-black">Editing the Styling</h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              If additional customization is required, the plugin’s appearance can be modified
              directly by editing the following files:
            </p>
            <ul className="ml-5 list-disc">
              <li className="text-black light">
                <code>basys-payment-styles.css</code>: The primary stylesheet controlling layouts.
              </li>
              <li className="text-black light">
                <code>styleLoader.js</code>: Contains styling logic specific to the embedded iframe,
                including injected styles for hosted fields.
              </li>
            </ul>
            <h2 className="font-normal text-black">HTML Structure Reference</h2>
            <p
              className="text-black light"
              style={{ textWrapMode: 'wrap', textWrapStyle: 'auto', width: '100%' }}
            >
              For convenience, the full HTML structure rendered by the plugin is provided below.
              This can be used as a reference when making targeted CSS or JavaScript customizations.
            </p>
            <CopyBlock
              text={`<div id="basys-payment-box" class="basys-payment-wrapper">
    <input type="hidden" name="basys_payment_method" id="basys_payment_method" value="card" />
    <!-- Toggle Buttons -->
    <div class="basys-payment-toggle hidden">
        <button type="button" id="select-card" class="toggle-button selected">Card</button>
        <button type="button" id="select-ach" class="toggle-button">ACH</button>
    </div>
    <!-- Card Payment -->
    <div class="payment-card-label hidden">Card Information</div>
    <div class="payment-card-section hidden">
        <div class="info-items">
            <div id="tokenex-container"></div>
        </div>
        <div class="info-items info-box">
            <input
                type="text"
                id="basys-expiration"
                name="expiration_date"
                placeholder="MM/YY"
                inputmode="numeric"
                autocomplete="cc-exp"
                maxlength="5"
                required
                pattern="^(0[1-9]|1[0-2])\\/\\d{2}$"
            />
        </div>
        <div class="info-items info-box">
            <div id="tokenex-container-cvv"></div>
        </div>
    </div>
    <!-- ACH Payment -->
    <?php if ($ach_enabled): ?>
        <div class="payment-bank-section" hidden>
            <div class="info-items">
                <label for="achAccountType">Account Type</label>
                <select id="achAccountType" name="achAccountType">
                    <option value="Checking">Checking</option>
                    <option value="Savings">Savings</option>
                </select>
            </div>
            <div class="info-items">
                <label for="routingNumber">Routing Number</label>
                <input
                    type="text"
                    id="routingNumber"
                    name="routingNumber"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="9"
                    pattern="^\\d{9}$"
                />
            </div>
            <div class="info-items">
                <label for="accountNumber">Account Number</label>
                <input
                    type="text"
                    id="accountNumber"
                    name="accountNumber"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="17"
                    pattern="^\\d{4,17}$"
                />
            </div>
        </div>
    <?php endif; ?>
    <?php if ($is_user_logged_in && $vault_customer_enabled): ?>
        <div class="vault-payment-option hidden">
            <input type="checkbox" id="basys-vault-payment" name="basys_vault_payment" />
            <label for="basys-vault-payment">Save payment method?</label>
        </div>
    <?php endif; ?>
</div>
`}
              theme={dracula}
              customStyle={{ overflowX: 'auto' }}
              language="php"
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default DeveloperWooCommerce;
